import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

export const pastTravelWithin2Years: AnswerPathTreeNode = {
  path: 'pastTravelWithin2Years',
  nodeId: 'lifestyle-travel-past-details-within-2years',
};
